import ProcessFlowBuilderModel from '~/models/tracked/processFlowBuilderModel';
import Notification from '~/models/notifications/notification';
import { IProcessFlow } from '~/interfaces/processFlowInterfaces';
import { INotificationsContainer } from '~/mixins/notificationsContainable';
import OnFlowErrorNotificationsContainable from '~/models/processFlows/mixins/onFlowErrorNotificationsContainable';

export default class OnFlowError extends OnFlowErrorNotificationsContainable(ProcessFlowBuilderModel)
  implements INotificationsContainer {
  parent: IProcessFlow;
  notifications: {[key: string]: Notification} = {};

  constructor(parent: IProcessFlow) {
    super();
    this.parent = parent;
  }

  get displayName(): string {
    return 'On Error';
  }

  get icon(): string {
    return 'exclamation';
  }
}